(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  // ── Accordion ──
  document.querySelectorAll('.faq-item__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var isOpen = item.classList.contains('faq-item--open');
      item.classList.toggle('faq-item--open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  // ── Category filter ──
  var tabs = document.querySelectorAll('.faq-tab');
  var items = document.querySelectorAll('.faq-item');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var cat = tab.dataset.cat;

      tabs.forEach(function (t) {
        t.classList.toggle('faq-tab--active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });

      items.forEach(function (item) {
        var match = cat === 'all' || item.dataset.cat === cat;
        item.style.display = match ? '' : 'none';
      });
    });
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function init() {
      var header    = document.getElementById('site-header');
      var hamburger = document.getElementById('nav-hamburger');
      var mobileNav = document.getElementById('mobile-nav');

      if (!header || !hamburger || !mobileNav) return;

      /* Offset header below announcement bar until it scrolls away */
      var announcementBar = document.querySelector('.announcement-bar');
      var secondaryBar    = document.querySelector('.announcement-bar-secondary');
      function updateHeaderTop() {
        var firstBarH = announcementBar ? announcementBar.offsetHeight : 0;
        var barHeight = Math.max(0, firstBarH - window.scrollY);
        header.style.top = barHeight + 'px';
        if (secondaryBar) secondaryBar.style.top = barHeight + 'px';
        header.classList.toggle('is-scrolled', window.scrollY > 10);
      }
      updateHeaderTop();
      window.addEventListener('scroll', updateHeaderTop, { passive: true });

      /* Mobile menu toggle */
      hamburger.addEventListener('click', function () {
        var isOpen = mobileNav.classList.contains('is-open');

        mobileNav.classList.toggle('is-open', !isOpen);
        mobileNav.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        hamburger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        hamburger.setAttribute(
          'aria-label',
          isOpen ? hamburger.dataset.labelOpen : hamburger.dataset.labelClose
        );
      });

      /* Close on link click */
      mobileNav.querySelectorAll('.mobile-nav__link').forEach(function (link) {
        link.addEventListener('click', function () {
          mobileNav.classList.remove('is-open');
          mobileNav.setAttribute('aria-hidden', 'true');
          hamburger.setAttribute('aria-expanded', 'false');
          hamburger.setAttribute('aria-label', hamburger.dataset.labelOpen);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
